import React from 'react';
import { Checkbox, CheckboxProps, Table } from 'semantic-ui-react';
import {
  BANK_CODES,
  RISK_LEVELS,
  ROLES,
  FIELDS_INFO,
  CLYM_FEE_ACCEPT_BANKS,
  PCI_NON_COMPLIANCE_MONTHLY,
  PCI_VALIDATION,
} from '../../../Utils/constants';

interface HarrisAndCentralOtherFeeSectionProps {
  voiceAuth: string;
  retreivalFee: string;
  achRejectFee: string;
  collectionsFee: string;
  pciValidation: string;
  pciNonCompliance: string;
  role: string | null;
  riskLevel: string;
  pricingCardValue: any
  amexOptubleSupportFee: string
  amexOptubleNetworkFee: string
  selectedBankOption: string;
  clymDataPrivacyCompliance: string;
  clymDataPrivacyComplianceFee: string;
  handleChangeTextInput: (e: any) => void;
  updatePricingSectionStatus: () => void;
  setClymDataPrivacyCompliance: (value: string) => void;
}
const clym_fee_accept_banks = Object.values(CLYM_FEE_ACCEPT_BANKS) as string[]

const HarrisAndCentralOtherFeeSection = ({
  voiceAuth,
  retreivalFee,
  achRejectFee,
  collectionsFee,
  pciValidation,
  pciNonCompliance,
  role,
  riskLevel,
  pricingCardValue,
  amexOptubleSupportFee,
  amexOptubleNetworkFee,
  selectedBankOption,
  clymDataPrivacyCompliance,
  clymDataPrivacyComplianceFee,
  handleChangeTextInput,
  updatePricingSectionStatus,
  setClymDataPrivacyCompliance
}: HarrisAndCentralOtherFeeSectionProps) => {
  const pciNonComplianceConfig = selectedBankOption
    ? PCI_NON_COMPLIANCE_MONTHLY[selectedBankOption as BANK_CODES]
    : undefined;
  const pciValidationConfig = selectedBankOption
    ? PCI_VALIDATION[selectedBankOption as BANK_CODES]
    : undefined;

  const pciNonComplianceEditable = pciNonComplianceConfig?.editable ?? true;
  const pciValidationEditable = pciValidationConfig?.editable ?? true;
  const isPciValidationMonthly = pciValidationConfig?.type === 'monthly';

  const pciValidationValue = pciValidationEditable
    ? (pciValidation || '')
    : ((pciValidationConfig?.fee ?? pciValidation) || '');

  const pciNonComplianceValue = pciNonComplianceEditable
    ? (pciNonCompliance || (pciNonComplianceConfig?.fee ?? ''))
    : ((pciNonComplianceConfig?.fee ?? pciNonCompliance) || '');

  return (
    <>
      <div className="grey-outline" style={{ padding: 0, marginTop: '20px' }}>
        <Table celled structured className="pricing-table">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan='4'>Other Fees</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>Voice Auth<span className="required-text"> *</span></Table.Cell>
              <Table.Cell>
                <span className='input-dollar'>$</span>
                <input
                  type='text'
                  name='voiceAuth'
                  className={!voiceAuth ? 'not-filled padding-left-30' : 'form-input padding-left-30'}
                  value={voiceAuth}
                  autoComplete="new-password"
                  disabled={role === ROLES.SALES_LIMITED}
                  onChange={handleChangeTextInput}
                  onBlur={updatePricingSectionStatus}
                />
              </Table.Cell>
              <Table.Cell>Retrieval Fee<span className="required-text"> *</span></Table.Cell>
              <Table.Cell>
                <span className='input-dollar'>$</span>
                <input
                  type='text'
                  name='retreivalFee'
                  className={!retreivalFee ? 'not-filled padding-left-30' : 'form-input padding-left-30'}
                  value="25"
                  autoComplete="new-password"
                  onChange={handleChangeTextInput}
                  disabled={role === ROLES.SALES_LIMITED}
                  onBlur={updatePricingSectionStatus}
                />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>NSF/ACH Reject Fee<span className="required-text"> *</span></Table.Cell>
              <Table.Cell>
                <span className='input-dollar'>$</span>
                <input
                  type='text'
                  name='achRejectFee'
                  value="25"
                  autoComplete="new-password"
                  onChange={handleChangeTextInput}
                  disabled={role === ROLES.SALES_LIMITED}
                  className={!achRejectFee ? 'not-filled padding-left-30' : 'form-input padding-left-30'}
                  onBlur={updatePricingSectionStatus}
                />
              </Table.Cell>
              <Table.Cell>Collection Fee<span className="required-text"> *</span></Table.Cell>
              <Table.Cell>
                <span className='input-dollar'>$</span>
                <input
                  type='text'
                  name='collectionsFee'
                  className={!collectionsFee ? 'not-filled padding-left-30' : 'form-input padding-left-30'}
                  value={collectionsFee}
                  autoComplete="new-password"
                  onChange={handleChangeTextInput}
                  disabled={role === ROLES.SALES_LIMITED}
                  onBlur={updatePricingSectionStatus}
                />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                PCI Validation ({isPciValidationMonthly ? 'Monthly' : 'Annual'})
                <span className="required-text"> *</span>
              </Table.Cell>
              <Table.Cell>
                <span className='input-dollar'>$</span>
                <input
                  type='text'
                  name='pciValidation'
                  value={pciValidationValue}
                  autoComplete="new-password"
                  onChange={handleChangeTextInput}
                  disabled={role === ROLES.SALES_LIMITED || !pciValidationEditable}
                  className={!pciValidationValue ? 'not-filled padding-left-30' : 'form-input padding-left-30'}
                  onBlur={updatePricingSectionStatus}
                />
              </Table.Cell>
              <Table.Cell>PCI Non-Compliance (Monthly)<span className="required-text"> *</span></Table.Cell>
              <Table.Cell>
                <span className='input-dollar'>$</span>
                <input
                  type='text'
                  name='pciNonCompliance'
                  value={pciNonComplianceValue}
                  autoComplete="new-password"
                  onChange={handleChangeTextInput}
                  disabled={role === ROLES.SALES_LIMITED || !pciNonComplianceEditable}
                  className={!pciNonComplianceValue ? 'not-filled padding-left-30' : 'form-input padding-left-30'}
                  onBlur={updatePricingSectionStatus}
                />
              </Table.Cell>
            </Table.Row>
            {pricingCardValue.includes('AMEX') && (
              <Table.Row>
                <Table.Cell>Amex OptBlue Support Fee<span className="required-text"> *</span> </Table.Cell>
                <Table.Cell>
                  <span className='input-dollar'>$</span>
                  <input
                    type='text'
                    name='amexOptubleSupportFee'
                    value={amexOptubleSupportFee}
                    autoComplete="new-password"
                    onChange={handleChangeTextInput}
                    disabled={role === ROLES.SALES_LIMITED}
                    onBlur={updatePricingSectionStatus}
                    className={!amexOptubleSupportFee ? 'not-filled padding-left-30' : 'form-input padding-left-30'}
                  />
                </Table.Cell>
                <Table.Cell>Amex OptBlue Network Fee<span className="required-text"> *</span></Table.Cell>
                <Table.Cell>
                  <span className='input-dollar'>$</span>
                  <input
                    type='text'
                    name='amexOptubleNetworkFee'
                    value={amexOptubleNetworkFee}
                    disabled={role === ROLES.SALES_LIMITED}
                    autoComplete="new-password"
                    onChange={handleChangeTextInput}
                    onBlur={updatePricingSectionStatus}
                    className={!amexOptubleNetworkFee ? 'not-filled padding-left-30' : 'form-input padding-left-30'}
                  />
                </Table.Cell>
              </Table.Row>
            )}
            {riskLevel === RISK_LEVELS.HIGH_RISK && clym_fee_accept_banks.indexOf(selectedBankOption) > -1 &&
              <Table.Row>
                <Table.Cell>Clym Data Privacy Compliance<span className='info1-icon' data-tooltip={FIELDS_INFO['Business Details'].clymDataPrivacyCompliance.helperText}></span><span className="required-text"> *</span></Table.Cell>
                <Table.Cell>
                  <Checkbox
                    label='Opt-In'
                    name=''
                    value=''
                    disabled={role === ROLES.SALES_LIMITED}
                    checked={clymDataPrivacyCompliance === 'Yes' ? true : false}
                    onChange={(event, data: CheckboxProps) => {
                      setClymDataPrivacyCompliance(data.checked ? 'Yes' : 'No')
                    }}
                  />
                </Table.Cell>
                <Table.Cell>
                  <span className='input-dollar'>$</span>
                  <input
                    type='text'
                    name='clymDataPrivacyComplianceFee'
                    value={clymDataPrivacyComplianceFee}
                    autoComplete="new-password"
                    onChange={handleChangeTextInput}
                    disabled={true}
                    className={!clymDataPrivacyComplianceFee ? 'not-filled padding-left-30' : 'form-input padding-left-30'}
                    onBlur={updatePricingSectionStatus}
                  />
                </Table.Cell>
              </Table.Row>
            }
          </Table.Body>
        </Table>
      </div>
    </>
  )
}
export default HarrisAndCentralOtherFeeSection;